<ng-container *transloco="let t">
    <div class="auth-container">
        <div class="button-container">
            <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="layout">
            <div class="welcome">
                <mat-icon
                    [svgIcon]="'lps-sign-up'"
                    class="sign-up-icon"
                ></mat-icon>
                <h1>{{ t("auth.sign-up.header") }}</h1>
                <p>{{ t("auth.sign-up.explanation") }}</p>
                <p>
                    <small>
                        {{ t("auth.sign-up.accountQuestion") }}
                        <a
                            [routerLink]="[
                                '',
                                { outlets: { auth: ['sign-in'] } }
                            ]"
                            [skipLocationChange]="true"
                            >{{ t("auth.sign-up.signIn") }}</a
                        >
                    </small>
                </p>
            </div>
            <div class="account-creation-container">
                <app-account-creation></app-account-creation>
            </div>
        </div>
    </div>
</ng-container>
